import React from "react";
import Skeleton from "../common/Skeleton";

const SmallStat = ({ title, value, subtitle, loading }) => (
    <div className="small-stat">

        {loading ? (
            <>
                <Skeleton width="40%" height={14}/>
                <div style={{ height: 8 }}/>
                <Skeleton width="30%" height={26}/>
                <div style={{ height: 6 }}/>
                <Skeleton width="60%" height={10}/>
            </>
        ) : (
            <>
                <div className="small-title">{title}</div>
                <div className="small-value">{value}</div>
                <div className="small-sub">{subtitle}</div>
            </>
        )}

    </div>
);

export default SmallStat;
